var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgColHeartinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.813 35.595"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.835 3.028a11.284 11.284 0 0115.949 15.949L21.741 35.038a1.881 1.881 0 01-2.671 0L3.028 18.977A11.284 11.284 0 0118.977 3.028l1.429 1.411 1.429-1.411zm13.3 13.3A7.53 7.53 0 0024.487 5.68l-2.746 2.765a1.881 1.881 0 01-2.671 0L16.325 5.68A7.527 7.527 0 105.68 16.325L20.406 31.05z"
  })));
}

export default SvgColHeartinline;